import React from 'react'
import _ from 'lodash'
import ReactDOM from 'react-dom'

import {LayoutStore} from '../stores'
import {Loading} from './'

import {Table as FixedTable, Column as FixedColumn} from 'fixed-data-table'

import SortableHeaderCell, {SortTypes} from './table/SortableHeaderCell.jsx'
import DefaultCell from './table/DefaultCell.jsx'
import DateTimeCell from './table/DateTimeCell.jsx'
import LinkCell from './table/LinkCell.jsx'

export {SortTypes, DefaultCell, DateTimeCell, LinkCell}

const defaultHeader = (item, onSortChange, onToggleColumn, sorting) => (
   <SortableHeaderCell
      onSortChange={onSortChange}
      columnKey={item.field}
      onToggleColumn={onToggleColumn}
      sortDir={sorting}
   >

      {item.name || item.field}
   </SortableHeaderCell>
)

const Cell = ({cell, getCell, ...props}) => {
   let ReplacementCell = getCell ? getCell(props) : cell

   if (ReplacementCell) {
      return <ReplacementCell {...props} />
   } else {
      return <DefaultCell {...props} />
   }
}

Cell.propTypes = {
   cell:    React.PropTypes.any,
   getCell: React.PropTypes.func
}

export const Column = (item, idx, rows, sorting) => {
   const {visible, header, width, flex, onSortChange, onToggleColumn, ...rest} = item

   if (visible) {
      return (
         <FixedColumn
            columnKey={item.field}
            key={idx}
            header={header || defaultHeader(item, onSortChange, onToggleColumn, sorting)}
            cell={props => (
               <Cell
                  cell={item.cell}
                  value={Column.transformation(item)(
                     Column.value(rows, props),
                     Column.fetch(rows, props),
                  )}
                  row={Column.fetch(rows, props)}
                  data={rows}
                  item={rest}
                  {...rest}
                  {...props}
               />
            )}
            width={width || 50}
            flexGrow={undefined === flex ? 1 : flex}
         />
      )
   }

   return null
}

Column.fetch = (rows, props) => rows[props.rowIndex]
Column.value = (rows, props) => _.get(rows[props.rowIndex], props.columnKey)
Column.transformation = col => (col.transform ? col.transform : _.identity)

Column.propTypes = {
   visible:        React.PropTypes.bool,
   header:         React.PropTypes.component,
   width:          React.PropTypes.number,
   flex:           React.PropTypes.number,
   rowIndex:       React.PropTypes.number.isRequired,
   onSortChange:   React.PropTypes.func.isRequired,
   onToggleColumn: React.PropTypes.func.isRequired
}

export class Table extends React.Component {
   static get propTypes() {
      return {
         rows:           React.PropTypes.array.isRequired,
         filter:         React.PropTypes.func,
         columns:        React.PropTypes.array,
         children:       React.PropTypes.oneOf([React.PropTypes.array, React.PropTypes.component]),
         onToggleColumn: React.PropTypes.func.isRequired,
         redraw:         React.PropTypes.any,
         onSortChange:   React.PropTypes.func,
         sorting:        React.PropTypes.array
      }
   }

   constructor(props) {
      super(props)

      this.state = {
         sortedRows: props.rows,
         sorting:    ['datetime', SortTypes.DEFAULT],
         columns:    [],
         dimensions: {width: -1, height: -1}
      }

      this._mounted = false

      this.onSortChange = this.onSortChange.bind(this)
   }

   componentWillMount() {
      this._mounted = true

      LayoutStore.addChangeListener(
         (this._layoutListener = () => {
            let dom = ReactDOM.findDOMNode(this._domelem)

            if (this._mounted && dom) {
               this.setState({dimensions: {width: dom.clientWidth, height: dom.clientHeight}})
            }
         }),
      )
   }

   componentDidMount() {
      // resize on mount
      if (this._layoutListener) {
         this._layoutListener()
      }
   }

   componentWillReceiveProps(next) {
      if (this.props.redraw !== next.redraw) {
         this._layoutListener()
      }
   }

   componentWillUnmount() {
      this._mounted = false

      LayoutStore.removeChangeListener(this._layoutListener)
   }

   onSortChange(field, sortDir) {
      const {sorting, onSortChange} = this.props

      if (!sorting) {
         this.setState({sorting: [field, sortDir]})
      }

      if (onSortChange) {
         onSortChange(field, sortDir)
      }
   }

   render() {
      const maxVisibleRowsCount = 20,
         {dimensions} = this.state,
         {rows, columns, onToggleColumn} = this.props,
         {width} = dimensions,
         sorting = this.props.sorting || this.state.sorting

      return (
         <Loading overlay={true} loading={null === rows}>

            <div
               ref={r => {
                  this._domelem = r
               }}
               className="table root"
            >

               <div className="table parent">
                  <FixedTable
                     rowsCount={_.size(rows)}
                     rowHeight={30}
                     headerHeight={30}
                     width={width ? width : 700}
                     height={Math.max(200, 32 + Math.min(maxVisibleRowsCount, _.size(rows)) * 30)}
                  >

                     {this.props.children
                        ? this.props.children
                        : _.map(
                             columns,
                             (v, k) => {
                                const props = {
                                   onSortChange:   this.onSortChange,
                                   onToggleColumn: onToggleColumn,
                                   ...v
                                }

                                return Column(
                                   props,
                                   k,
                                   rows,
                                   sorting[0] === v.field ? sorting[1] : null,
                                )
                             },
                             this,
                          )}

                  </FixedTable>

                  <b>Items; {_.size(rows)}</b>
               </div>

            </div>

         </Loading>
      )
   }
}



// WEBPACK FOOTER //
// lib/ui/Table.jsx